import { render, staticRenderFns } from "./Establishments.vue?vue&type=template&id=04a24bc4"
import script from "./Establishments.vue?vue&type=script&lang=js"
export * from "./Establishments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports